import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { FormAdd } from 'grommet-icons';

import { withNamespaces } from 'react-i18next';
import { formatNumberToPlaces } from 'utils/numbers';
import { PrettyNumberTZ } from 'components/Helpers';
import { Box, Text } from 'components/Wrapped';

const CreateOrderBalance = ({ portfolios, mgokx, markets, balances, tradingPair, side, margin = { bottom: '4px' }, t }) => {
  const currency = side === 'BUY' ? tradingPair.quoteCurrency : tradingPair.baseCurrency;

  let balance = _.get(portfolios, `${currency}.balance`, 0);

  if (mgokx.enabled) {
    const isNDWallet = _.get(markets, ['prices', tradingPair.quoteCurrency, tradingPair.baseCurrency, 'isNDWallet'], false);
    if (isNDWallet) {
      balances.forEach((el) => {
        if (el.currency === currency) {
          balance = el.trading_balance;
        }
      });
    }
  }

  return (
    <Box pad="none" direction="row" align="center" justify="between" margin={margin}>
      {/* <Text size="inherit">{t('forms.coinBalance')}</Text> */}
      <Text color="#B4B6B7" size="11px" weight={500}>
        Доступно
      </Text>
      <Box pad="none" gap="5px" direction="row" align="center">
        <Text color="#B4B6B7" size="12px" weight={500} style={{ lineHeight: '15px' }}>
          {currency}
        </Text>
        <PrettyNumberTZ color="white" weight={500} size="12px" number={formatNumberToPlaces(balance, 2)} style={{ lineHeight: '15px' }} />
        <FormAdd
          color="white"
          size="16px"
          style={{
            background: '#568677',
            borderRadius: '50%',
            cursor: 'pointer',
          }}
        />
      </Box>
    </Box>
  );
};

CreateOrderBalance.propTypes = {
  tradingPair: PropTypes.shape({
    baseCurrency: PropTypes.string,
    quoteCurrency: PropTypes.string,
  }).isRequired,
  side: PropTypes.oneOf(['BUY', 'SELL']),
};

const mapStateToProps = ({ portfolio, markets, NDWalletData, exchangeSettings: { settings } }) => ({
  portfolios: portfolio.portfolios,
  markets: markets,
  balances: NDWalletData.balance,
  mgokx: settings.mgokx,
});

export default withNamespaces()(connect(mapStateToProps)(CreateOrderBalance));
